
import React from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

const Login = () => {
    const { signInWithGoolge } = useAuth()
    const navigate = useNavigate()
    return (
        <div style={{
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }}>
            <Button onClick={() => signInWithGoolge(navigate)}>Login</Button>
        </div>
    );
};

export default Login;